var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClienthome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "currentcolor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.19785 11.489V16.489C8.19785 17.039 7.74785 17.489 7.19785 17.489H3.19785C2.64785 17.489 2.19785 17.039 2.19785 16.489V9.48898H0.497852C0.037852 9.48898 -0.172148 8.91898 0.167852 8.61898L8.52785 1.08898C8.90785 0.748984 9.48785 0.748984 9.86785 1.08898L18.2279 8.61898C18.5779 8.91898 18.3579 9.48898 17.8979 9.48898H16.1979V16.489C16.1979 17.039 15.7479 17.489 15.1979 17.489H11.1979C10.6479 17.489 10.1979 17.039 10.1979 16.489V11.489H8.19785ZM14.1979 7.90167C14.1979 7.75992 14.1377 7.62484 14.0323 7.53002L9.53233 3.48002C9.34218 3.30888 9.05352 3.30888 8.86337 3.48002L4.36337 7.53002C4.25801 7.62484 4.19785 7.75992 4.19785 7.90167V14.989C4.19785 15.2651 4.42171 15.489 4.69785 15.489H5.69785C5.97399 15.489 6.19785 15.2651 6.19785 14.989V9.48898H12.1979V14.989C12.1979 15.2651 12.4217 15.489 12.6979 15.489H13.6979C13.974 15.489 14.1979 15.2651 14.1979 14.989V7.90167Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClienthome);
export default __webpack_public_path__ + "static/media/clienthome.1cc8f77779c24b02904315603a800a2a.svg";
export { ForwardRef as ReactComponent };